import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  Row,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { useChangeOrderStatus, useOrderStatus } from "hooks/order/useOrder";
import Select from "react-select";

const ChangeStatus = ({
  orderDetail,
  isOpenChangeStatusModal,
  setIsOpenChangeStatusModal,
  refetchDetail,
}) => {
  const { t } = useTranslation(["bloodOrder"]);

  const schema = yup.object().shape({
    status_id: yup
      .object()
      .required(t("message.select_required", { target: "Trạng thái" })),
    note: yup
      .string()
      .required(t("message.enter_required", { target: "Lý do" })),
  });

  const {
    reset,
    formState: { errors },
    control,
    getValues,
    register,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const closeChangeStatusModal = () => {
    setIsOpenChangeStatusModal(false);
    reset();
    refetchDetail();
  };
  const { data: orderStatusList } = useOrderStatus();
  const { mutate: changeOrderStatus } = useChangeOrderStatus(
    closeChangeStatusModal
  );

  const onSubmit = () => {
    trigger().then(isValid => {
      if (isValid) {
        const formValue = getValues();
        const bodyData = {
          order_id: orderDetail?.id,
          status: formValue.status_id.value,
          note: formValue.note,
        };
        changeOrderStatus(bodyData);
      }
    });
  };

  return (
    <>
      <Modal
        centered
        isOpen={isOpenChangeStatusModal}
        toggle={closeChangeStatusModal}
      >
        <ModalHeader>Đổi trạng thái</ModalHeader>
        <Form className="p-3">
          <Row>
            <Col xs={12}>
              <FormGroup className="gy-2">
                <Label htmlFor="status_id">
                  Trạng thái <span className="text-danger">*</span>
                </Label>

                <Controller
                  control={control}
                  name="status_id"
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.status_id"),
                      })}
                      options={orderStatusList || []}
                      isSearchable
                      className="basic-single w-100"
                      classNamePrefix="select"
                    />
                  )}
                />
                {errors.status_id && (
                  <MessageFormValidate error={errors.status_id.message} />
                )}
              </FormGroup>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <Label htmlFor="note">
                  Lý do <span className="text-danger">*</span>
                </Label>
                <textarea
                  type="textarea"
                  className={`form-control `}
                  name="note"
                  placeholder="Ghi chú lại lý do"
                  rows={5}
                  {...register("note")}
                />
                {errors.note && (
                  <MessageFormValidate error={errors.note.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <div className="d-flex justify-content-end gap-2">
                <Button color="danger" onClick={closeChangeStatusModal}>
                  Huỷ
                </Button>
                <Button color="primary" onClick={onSubmit}>
                  Xác nhận
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default ChangeStatus;
